export default __webpack_public_path__ + "static/media/apeswap.59a52461.svg";